import loadable from '@loadable/component'
import React from 'react'

import Hero from '../hero'
import Breadcrumbs from '~/components/breadcrumbs'
import LandingForm from '~/components/landing-form/form-types/interactive'
import { LandingForm as RoundedLandingForm } from '~/components/landing-form/form-types/rounded'
import * as st from '~/components/local/styles'
import { usePageContext } from '~/contexts/page-context'
import { styles as themeStyles } from '~/styles/theme'

const MapBackground = loadable(() => import('../../local/map-static'))

const LocalHeroContent = ({
  headerText,
  title,
  customerAddress,
  currentProvider,
  onUpdate,
  loading,
  children = null
}) => {
  const { locality } = usePageContext()

  return (
    <Hero p0Fetched={{ current: false }}>
      <div sx={st.localHeroContainer}>
        <div sx={st.localHeroContainerHalfAndHalf}>
          <MapBackground />
          <Breadcrumbs />

          <div sx={st.formRow}>
            <div sx={st.formContainerCol}>
              <div sx={st.titleContainer}>
                <div sx={st.formRow}>
                  {children ? (
                    <div>{children}</div>
                  ) : (
                    <div sx={st.heroContent}>
                      <h1 sx={themeStyles.h1}>{title}</h1>
                      <p>{headerText}</p>
                    </div>
                  )}
                </div>

                <div sx={st.heroForm} id='input-form'>
                  {locality ? (
                    <RoundedLandingForm
                      customerAddress={customerAddress}
                      onUpdate={onUpdate}
                      provider={currentProvider}
                      isFetchingAddress={loading}
                    />
                  ) : (
                    <LandingForm variant='landing-form' />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Hero>
  )
}

export default LocalHeroContent
